module.exports = __webpack_public_path__ + "static/media/adesivo_schirmann.d3af9edc.png";